import { useEffect, useState } from 'react';

function obterLarguraAtual() {
  if (typeof window === 'undefined') return 1280;
  return window.innerWidth || 1280;
}

export function useLarguraTela() {
  const [larguraTela, setLarguraTela] = useState(obterLarguraAtual);

  useEffect(() => {
    const atualizarLargura = () => setLarguraTela(obterLarguraAtual());
    window.addEventListener('resize', atualizarLargura);
    return () => window.removeEventListener('resize', atualizarLargura);
  }, []);

  return larguraTela;
}
